import { getFeatureFlag, isString } from "@sinch/feature-flags";
import { config, type FinalShellEnv } from "./client";

declare global {
  interface Window {
    SHELL_ENV: FinalShellEnv;
  }
}

console.log("config loaded with env:", window.SHELL_ENV);

export const getMessageMediaApiUrlMiddleware = () =>
  getFeatureFlag("messageMediaApiUrlMiddleware", isString, config.API_BASE_URL);
export const getMessageMediaApiUrl = () =>
  getFeatureFlag(
    "messageMediaApiUrl",
    isString,
    config.SHELL_ENV.NEXTGEN_API_URL
  );
export const getOnesaasApiUrlAuth = () =>
  getFeatureFlag("onesaasApiUrlAuth", isString, config.AUTH_CONFIG.url);

export const getZendeskScriptUrl = () =>
  "https://static.zdassets.com/ekr/snippet.js?key=";
